export default "__VITE_ASSET__C9m$v8Wu__"